import { Component, h } from 'preact'
import SSOOverviewPresenter from './SSOOverviewPresenter'
import SAMLSetup from './SAMLSetup'

interface Props {
  ssoProxyUrl: string
}

interface State {
    showSAMLSetup: boolean
}

class SSOOverview extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      showSAMLSetup: false
    }
    this.showSAMLSetup = this.showSAMLSetup.bind(this)
  }

  showSAMLSetup () {
    this.setState({ showSAMLSetup: true })
  }

  render ({ ssoProxyUrl }: Props, { showSAMLSetup }: State) {
    return (
      <div>
        {showSAMLSetup
          ? <SAMLSetup
            ssoProxyUrl={ssoProxyUrl}
          />
          : <SSOOverviewPresenter
            onSAMLInstall={this.showSAMLSetup}
          />
        }
      </div>
    )
  }
}

export default SSOOverview
